module.exports = __webpack_public_path__ + "img/slider_1.67d1a8ec.jpg";